import { AppStore } from './AppStore';

/**
 * Root store that contains all application stores.
 *
 * This implements the "root store pattern" for MobX, allowing:
 * - Easy access to all stores from any component
 * - Cross-store communication
 * - Centralized store initialization
 *
 * @example
 * ```tsx
 * const rootStore = new RootStore();
 * rootStore.appStore.setConnectionStatus('connected');
 * ```
 */
export class RootStore {
  /** Application-level state (loading, errors, connection) */
  readonly appStore: AppStore;

  constructor() {
    // Initialize stores with reference to root for cross-store access
    this.appStore = new AppStore(this);
  }

  /**
   * Reset all stores to their initial state.
   * Useful for logout or testing.
   */
  reset(): void {
    this.appStore.reset();
  }
}

/**
 * Singleton instance of the root store.
 * Created once and shared across the application.
 */
export const rootStore = new RootStore();
